<template>
  <div class="sc-flyout StudentChoiceNavBarMenuGroup">
    <button
      class="sc-flyout-button"
      aria-haspopup="true"
      :aria-expanded="jumpToMenuOpen"
      :expanded="jumpToMenuOpen"
      @click="toggleJumpToMenu"
    >
      <span class="sc-flyout-button-text">{{ title || "" }}</span
      ><span class="icon-down-open-big"></span>
    </button>
    <div class="sc-flyout-menu" :class="{ open: jumpToMenuOpen }">
      <div class="sc-menu">
        <div class="sc-menu-items">
          <div
            class="sc-link link sc-menu-link"
            v-for="link in items"
            :key="link.linkText"
          >
            <router-link :to="link.to" v-if="!link.externalLink && !link.href">
              {{ link.linkText }}
            </router-link>
            <a v-else :href="link.href || ''"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { JumpToMenuLink } from "@/types/jumpto-menu";

const props = defineProps<{
  title: string;
  items: JumpToMenuLink[];
}>();

const jumpToMenuOpen = ref<boolean>(false);

function toggleJumpToMenu() {
  jumpToMenuOpen.value = !jumpToMenuOpen.value;
}
</script>

<style scoped>
.sc-flyout {
  position: relative;
}

.sc-flyout-button {
  display: flex;
  align-items: center;
  padding: 0 12px;
  padding: 0;
  height: 15px;
  color: transparent;
  gap: 7px;
  padding-left: 60px;
  background-color: transparent;
  border: none;
}
.sc-flyout-button-text {
  color: #000;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.icon-down-open-big:before {
  color: #000;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.sc-flyout-menu {
  display: flex;
  position: absolute;
  top: calc(var(--xbreadcrumb-height) / 2 + 15px);
  right: 0;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: opacity 0.25s, visibility 0.25s, transform 0.25s;
  border-radius: 4px;
}

.sc-menu {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  overflow: auto;
  min-width: 134px;
  border: 0.5px solid #fff;
}

.sc-menu-items {
  transition: border-color 0.5s;
}
.sc-menu-link {
  display: block;
  line-height: normal;
  font-size: 13px;
  font-weight: 400;
  white-space: nowrap;
  transition: color 0.25s;
  cursor: pointer;
  padding: 9px 11px;
  text-align: left;
}
.sc-menu-link:hover {
  font-weight: 700;
  background: #e2e4e9;
}
.sc-flyout:hover .sc-flyout-menu,
.sc-flyout-button[aria-expanded="true"] + .sc-flyout-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
</style>
